'use strict';

// リーグ日別成績: pt推移チャート描画
$(document).on('turbolinks:load', function () {
  initDailyStatsCharts();
});

$(document).on('turbolinks:before-cache', function () {
  destroyDailyStatsCharts();
});

var dailyStatsCharts = {};

// リーグ詳細の総合pt推移グラフと同じ描画プラグイン（0ptライン・クロスヘア）を返す
function commonLinePlugins() {
  if (!window.JanrecoUtils) return [];

  return [window.JanrecoUtils.zeroLinePlugin, window.JanrecoUtils.crosshairLinePlugin];
}

function initDailyStatsCharts() {
  var canvases = document.querySelectorAll('.daily-stats-line-graph');
  if (!canvases.length) return;

  canvases.forEach(function (canvas) {
    var id = canvas.id;
    if (!id) return;

    var rawDatasets = canvas.getAttribute('data-datasets');
    var rawLabels = canvas.getAttribute('data-labels');
    var yMax = Number(canvas.getAttribute('data-ymax')) || 100;
    var yMin = Number(canvas.getAttribute('data-ymin')) || -100;
    // ツールチップ見出しの書式（例: '{n}対局目'）。JSに日本語を書かないためビューから受け取る
    const matchIndexFormat = canvas.getAttribute('data-match-index-format') || '';

    if (!rawDatasets || !rawLabels) return;

    var datasets = JSON.parse(rawDatasets);
    var labels = JSON.parse(rawLabels);

    if (dailyStatsCharts[id]) {
      dailyStatsCharts[id].destroy();
    }

    dailyStatsCharts[id] = new Chart(canvas, {
      type: 'line',
      data: {
        labels: labels,
        datasets: datasets
      },
      // 0ptの点線・ホバー時の縦点線はリーグ詳細の総合pt推移グラフと共通のプラグインを使う
      plugins: commonLinePlugins(),
      options: {
        animation: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false,
            // ホバーした1人（1チーム）だけを表示する（全員をまとめると読み取りづらいため）
            mode: 'nearest',
            intersect: false,
            external: window.JanrecoUtils ? window.JanrecoUtils.externalTooltipHandler : undefined,
            callbacks: {
              // x軸ラベルは連番のみなのでリーグ詳細と同じ「N対局目」形式に整える（0pt起点は見出しなし）
              title: function (context) {
                const idx = context[0].dataIndex;
                if (idx === 0) return '';
                if (!matchIndexFormat) return context[0].label || '';

                return matchIndexFormat.replace('{n}', idx);
              },
              label: function (context) {
                return context.dataset.label + ': ' + context.raw + 'pt';
              }
            }
          }
        },
        elements: {
          line: { borderWidth: 2 }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            max: yMax,
            min: yMin,
            ticks: {
              stepSize: 100,
              font: { size: 10 }
            }
          },
          x: {
            grid: { display: false },
            ticks: {
              maxRotation: 0,
              minRotation: 0,
              font: { size: 10 }
            }
          }
        }
      }
    });
  });

  initDailyStatsLegends();
}

function initDailyStatsLegends() {
  document.querySelectorAll('.team-legend-item[data-chart-id]').forEach(function (item) {
    item.addEventListener('click', function () {
      var chartId = this.dataset.chartId;
      var index = parseInt(this.dataset.index, 10);
      var chart = dailyStatsCharts[chartId];
      if (!chart) return;

      var meta = chart.getDatasetMeta(index);
      meta.hidden = !meta.hidden;
      this.style.opacity = meta.hidden ? '0.3' : '1';
      chart.update();
    });
  });

  // チームロゴクリックでチーム全員の表示/非表示をトグルする（リーグ詳細のグラフと同じ挙動）
  document.querySelectorAll('.team-logo-toggle[data-chart-id]').forEach(function (logo) {
    logo.addEventListener('click', function () {
      var chart = dailyStatsCharts[this.dataset.chartId];
      if (!chart) return;

      var indices = JSON.parse(this.dataset.teamIndices || '[]');
      // 1つでも表示中なら全て非表示、全て非表示なら全て表示
      var newHidden = indices.some(function (idx) {
        return !chart.getDatasetMeta(idx).hidden;
      });

      indices.forEach(function (idx) {
        chart.getDatasetMeta(idx).hidden = newHidden;
      });

      var row = this.closest('.graph-legend-team-row');
      if (row) {
        row.querySelectorAll('.team-legend-item').forEach(function (item) {
          item.style.opacity = newHidden ? '0.3' : '1';
        });
      }
      this.style.opacity = newHidden ? '0.3' : '1';

      chart.update();
    });
  });
}

function destroyDailyStatsCharts() {
  Object.keys(dailyStatsCharts).forEach(function (id) {
    if (dailyStatsCharts[id]) {
      dailyStatsCharts[id].destroy();
    }
  });
  dailyStatsCharts = {};
}
